import { render } from "./table.vue?vue&type=template&id=1ed5d6bf&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=1ed5d6bf&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed5d6bf"]])

export default __exports__